"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetStagedChanges = exports.newRelicAppIdChange = exports.sentryDsnChange = exports.AppActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _createAction = _interopRequireDefault(require("flux-actions/createAction"));

var AppActionTypes = (0, _namespacedKeyMirror.default)({
  APP_STARTED: null,
  SENTRY_DSN_CHANGED: null,
  NEW_RELIC_APP_ID_CHANGED: null,
  RESET_STAGED_CHANGES: null
}, '@@settingsui-root');
exports.AppActionTypes = AppActionTypes;
var sentryDsnChange = (0, _createAction.default)(AppActionTypes.SENTRY_DSN_CHANGED, function (dsn) {
  return dsn;
});
exports.sentryDsnChange = sentryDsnChange;
var newRelicAppIdChange = (0, _createAction.default)(AppActionTypes.NEW_RELIC_APP_ID_CHANGED, function (newRelicAppId) {
  return newRelicAppId;
});
exports.newRelicAppIdChange = newRelicAppIdChange;
var resetStagedChanges = (0, _createAction.default)(AppActionTypes.RESET_STAGED_CHANGES);
exports.resetStagedChanges = resetStagedChanges;